import { FolderPicker } from "./FolderPicker";
import "./index.css";

export function App() {
  return (
    <div className="my-12 mx-24 max-w-7xl">
      <span className="text-sm">DirTreeMd.com</span>
      <h1 className="text-xl text-bold mb-4">Directory Tree Markdown</h1>
      <pre>
        <FolderPicker></FolderPicker>
      </pre>
    </div>
  );
}

export default App;
